import { useState } from 'react';
import type { ImageDimensions } from '@/shared/model/imageDimensions';

/** Уточняет разрешение по уже загруженным изображениям без дополнительных запросов */
export const useImageDimensions = () => {
    const [byUrl, setByUrl] = useState<Record<string, ImageDimensions>>({});

    /** Запоминает естественный размер успешно загруженного изображения */
    const recordDimensions = (url: string | null | undefined, image: HTMLImageElement): void => {
        const width = image.naturalWidth;
        const height = image.naturalHeight;

        if (!url || width <= 0 || height <= 0) return;

        setByUrl(previous => previous[url]?.width === width && previous[url]?.height === height
            ? previous
            : {
                ...previous,
                [url]: {
                    width,
                    height
                }
            });
    };

    /** Использует метаданные сервера либо разрешение загруженного оригинала */
    const getDimensions = (
        url: string | null | undefined,
        width?: number | null,
        height?: number | null,
    ): ImageDimensions | undefined => width != null && width > 0 && height != null && height > 0
            ? {
                width,
                height
            }
            : byUrl[url ?? ''];

    return {
        recordDimensions,
        getDimensions
    };
};
